var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.456543aff7a6ae2c16da0ed81e75df04.svg#h';
                    var viewUrl = 'sprites.456543aff7a6ae2c16da0ed81e75df04.svg#view-h';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 12 14',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };